import React from "react";
import { TRIAL_ATTENDANCE_STATUS } from "../../../../constants/enrollments";
import { resolveTrialAttendance } from "../helpers";

const StatCard = ({ title, value, icon, color, subtitle }) => (
    <div className="d-flex align-items-start h-100 p-2">
        <div className={`me-3 text-${color}`} style={{ marginTop: '2px' }}>
            <i className={`${icon} font-size-24`}></i>
        </div>
        <div>
            <p className="text-muted mb-0 text-truncate font-size-12 lh-1">{title}</p>
            <h5 className="mb-0 mt-1 fw-bold">{value}</h5>
            {subtitle && (
                <small className={`text-${color} mt-1 d-block font-size-11 opacity-75`}>
                    {subtitle}
                </small>
            )}
        </div>
    </div>
);

const TrialsStats = ({ trials = [] }) => {
    const total = trials.length;
    const attended = trials.filter((t) => resolveTrialAttendance(t) === TRIAL_ATTENDANCE_STATUS.PRESENT).length;
    const noShow = trials.filter((t) => resolveTrialAttendance(t) === TRIAL_ATTENDANCE_STATUS.ABSENT).length;
    const converted = trials.filter((t) => t.convertedToSale === true).length;

    const totalPast = trials.filter((t) => new Date(t.sessionDate) < new Date()).length;
    const future = trials.filter((t) => new Date(t.sessionDate) >= new Date()).length;

    // Taxa de conversão: convertidos / total de experimentais passadas
    const conversionRate = totalPast > 0 ? Math.round((converted / totalPast) * 100) : 0;

    return (
        <div className="row g-3 mb-4">
            <div className="col-6 col-lg-3">
                <StatCard
                    title="Total Agendado"
                    value={total}
                    icon="mdi mdi-calendar-clock"
                    color="primary"
                    subtitle={`${future} previstas`}
                />
            </div>
            <div className="col-6 col-lg-3">
                <StatCard
                    title="Comparecimento"
                    value={attended}
                    icon="mdi mdi-check-circle-outline"
                    color="success"
                    subtitle={totalPast > 0 ? `${Math.round((attended / totalPast) * 100)}% das ${totalPast} passadas` : "Sem dados"}
                />
            </div>
            <div className="col-6 col-lg-3">
                <StatCard
                    title="No-Show (Faltas)"
                    value={noShow}
                    icon="mdi mdi-close-circle-outline"
                    color="danger"
                    subtitle={totalPast > 0 ? `${Math.round((noShow / totalPast) * 100)}% das ${totalPast} passadas` : "Sem dados"}
                />
            </div>
            <div className="col-6 col-lg-3">
                <StatCard
                    title="Taxa de Conversão"
                    value={`${conversionRate}%`}
                    icon="mdi mdi-trophy-outline"
                    color="warning"
                    subtitle={`${converted} de ${totalPast} convertidos`}
                />
            </div>
        </div>
    );
};

export default TrialsStats;
